import React from 'react';
import PropTypes from 'prop-types';

import {
  FDBodyText, FDIcon, FDPaper, FDStack,
} from '@facet-wealth/design';

function TrustRevocabilityWarning({
  value,
}) {
  return (
    <FDPaper color={'error'} appearance={'flat'} padding={2}>
      <FDStack direction={'row'} spacing={1} alignItems={'center'}>
        <FDIcon icon={'info'} color={'error'} />
        <FDBodyText value={value} color={'textError'} />
      </FDStack>
    </FDPaper>
  );
}

TrustRevocabilityWarning.defaultProps = {
  value: null,
};

TrustRevocabilityWarning.propTypes = {
  value: PropTypes.node,
};

export default TrustRevocabilityWarning;
